"use client";

import { Typography } from "@kyan/ui";
import { utc } from "moment";
import { useEffect, useState } from "react";

export const DateAndTime = () => {
  const [currentTime, setCurrentTime] = useState<string>("");
  const [currentDate, setCurrentDate] = useState<string>("");

  useEffect(() => {
    const updateDateTime = () => {
      const now = utc();
      setCurrentTime(now.format("HH:mm:ss UTC"));
      setCurrentDate(now.format("MMMM D, YYYY"));
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="flex flex-col items-end gap-1">
      <Typography grotesk size={11} className="leading-none whitespace-nowrap">
        {currentTime}
      </Typography>
      <Typography
        xs
        primary
        className="leading-none whitespace-nowrap uppercase"
      >
        {currentDate}
      </Typography>
    </div>
  );
};
